import { render, staticRenderFns } from "./xeDataCard.vue?vue&type=template&id=1c1b8930&scoped=true"
import script from "./xeDataCard.vue?vue&type=script&lang=js"
export * from "./xeDataCard.vue?vue&type=script&lang=js"
import style0 from "./xeDataCard.vue?vue&type=style&index=0&id=1c1b8930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1b8930",
  null
  
)

export default component.exports